import {
  SortChangedEvent,
  GridColumnsChangedEvent,
  DragStoppedEvent,
} from "@ag-grid-community/all-modules";

export enum GridPrefKey {
  COL_STATE = "colState",
  GROUP_STATE = "groupState",
  FILTER_STATE = "filterState",
  ORDER_STATE = "orderState",
}

export enum GridKey {
  HISTORY_GRID = "history_grid",
  EMPLOYEE_GRID = "employee_grid",
  USERS_GRID = "users_grid",
  ACCESS_LOGS_GRID = "access_logs_grid",
  DATA_PAGES_GRID = "dp_grid",
}

export type savePrefParams =
  | CustomEvent<SortChangedEvent>
  | CustomEvent<GridColumnsChangedEvent>
  | CustomEvent<DragStoppedEvent>;
